const earthRadius = 6371; // km

export const orbitShort = {
	"Geostationary Orbit": "GEO",
	"Low Earth Orbit": "LEO",
	"Medium Earth Orbit": "MEO",
	"High Earth Orbit / Cislunar Space": "HEO / Cis",
	"Highly Elliptical Orbit": "Elliptical",
};

/** toOrbitShortName returns a short display name for the given orbit description, for
    display in small spaces. */
export const toOrbitShortName = (orb) => orbitShort[orb] || orb;

export const calculateOrbitType = (periapsis, apoapsis, period) => {
	if (!periapsis && !apoapsis && !period) {
		return undefined;
	}

	const eccentricity =
		(apoapsis - periapsis) / (apoapsis + periapsis + 2 * earthRadius);

	if (eccentricity > 0.5) {
		return "Highly Elliptical Orbit";
	} else if (Math.abs(24 * 60 - parseFloat(period)) < 14) {
		return "Geostationary Orbit";
	} else if (apoapsis >= 35000) {
		return "High Earth Orbit / Cislunar Space";
	} else if (apoapsis < 35000 && apoapsis >= 2000) {
		return "Medium Earth Orbit";
	} else {
		return "Low Earth Orbit";
	}
};

export const orbitTypes = [
	"Geostationary Orbit",
	"Low Earth Orbit",
	"Medium Earth Orbit",
	"High Earth Orbit / Cislunar Space",
	"Highly Elliptical Orbit",
];
